import React from 'react';
import { Box, BoxProps, Close } from '@apia/theme';

export interface ILabelBox {
  className?: string;
  label: string;
  tooltip?: string;
  closeTooltip?: string;
  onClose?: () => unknown;
}

type TLabelBox = ILabelBox & BoxProps;

export const LabelBox = ({
  className,
  label,
  tooltip,
  closeTooltip,
  onClose,
  ...props
}: TLabelBox) => {
  return (
    <Box
      {...props}
      title={tooltip}
      className={`labelBox ${className ?? ''}`}
      variant="layout.common.boxes.labelBox"
    >
      <Box className="labelAndIcon" as="span">
        {label}
      </Box>
      <Box>
        <Close
          type="button"
          className="closeButton"
          onClick={onClose}
          disabled={!onClose}
          title={closeTooltip}
          variant="icon-outline-danger"
        />
      </Box>
    </Box>
  );
};
